import { Placement } from "./Placement";
import Sprite from "../components/object-graphics/Sprite";
import { TILES } from "../helpers/tiles";
import { Z_INDEX_LAYER_SIZE } from "../helpers/consts";

export class ParticleExlosionPlacement extends Placement {
  constructor(properties, level) {
    super(properties, level);
    this.frame = 1;
  }

  tick() {
    if (this.frame <= 8) {
      this.frame += 0.5;
    } else {
      this.level.removeLivePlacement(this);
    }
  }

  getZIndex() {
    return this.y * Z_INDEX_LAYER_SIZE + 2; //+2 above anything else in this layer
  }

  renderComponent() {
    const frameCoord = `PARTICLE_${Math.ceil(this.frame)}`;
    return <Sprite frameCoord={TILES[frameCoord]} />;
  }
}
